<template>
  <div class="page">
    <h1 class="text-h3">You successfully registered!</h1>
    <p class="body-1">
      Next steps: Verify your email, set your password. Then,
      <router-link :to="{ name: 'project-list' }">sign in</router-link>.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
